import {POObject} from './POObject';

export class PODocScan extends POObject {
  static type = 'DocScan';

  id = 0;
  base64Data = '';
  type = PODocScan.type;
}
